// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"ca3f1e19","486":"1c2e7880"}[chunkId] + ".chunk.js";
};